module.exports = __webpack_public_path__ + "static/img/about_authority_02_zh.1ebdb53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about_authority_02_zh.png
// module id = 3JiN
// module chunks = 34